import { RouteInfo } from './sidebar.metadata';
export function getAlldata3() {
 const agROUTES: RouteInfo[] = [];

 if (sessionStorage.getItem('claimFinancing') == 'true') {
    agROUTES.push(
        {
            path: '', title: 'Claim Financing', icon: 'ft-aperture', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
            submenu: [
                {
                    path: '/Aggregator/Aggregator/Dashboard/DashboardAggregator', title: 'Dashboard', icon: 'fa fa-tachometer', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                },
              
                {
                    path: '/Aggregator/Aggregator/Invoice/invoices', title: 'Invoice', icon: 'fa fa-hospital-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                },
                {
                    path: '/Aggregator/Aggregator/hospital/Hospital', title: 'Hospital', icon: 'fa fa-hospital-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                },
                {
                    path: '/Aggregator/Aggregator/UploadInvoice/Uploadinvoice', title: 'Upload Invoice', icon: 'fa fa-user', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                },
              
              {
                path: '/Aggregator/Aggregator/hospital/editProfileAggregator', title: 'Edit profile', icon: 'fa fa-pencil-square-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
            },
         
                {
                    path: '/Aggregator/Aggregator/bulkrepayment/bulk-repayment', title: 'Bulk Repayment', icon: 'fa fa-user', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                },


            ]
        },
    )
}
   
if (sessionStorage.getItem('patientFinancing') == 'true'&& sessionStorage.getItem('organizationName') != 'AyuHealth') {
    agROUTES.push(
        {
            path: '', title: 'Patient Financing', icon: 'ft-aperture', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
            submenu: [
                {
                    path: '/Aggregator/Patient/Dashboard/DashboardPracto', title: 'Dashboard', icon: 'fa fa-tachometer', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                },
                {
                    path: '/Aggregator/Patient/Forms/form', title: 'Uninsured', icon: 'ft-aperture', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                },
                {
                    path: '/Aggregator/Patient/Reimbursement/Add_New_Patient', title: 'Reimbursement', icon: 'ft-aperture', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                },
              
                {
                  path: '/Aggregator/Patient/Invoices/Invoice', title: 'Invoices', icon: 'ft-aperture', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
              },

            ]
        },
    )
}
if (sessionStorage.getItem('patientFinancing') == 'true' && sessionStorage.getItem('organizationName') == 'AyuHealth') {
    agROUTES.push(
        {
            path: '', title: 'Patient Financing', icon: 'ft-aperture', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
            submenu: [
                {
                    path: '/Aggregator/Patient/Dashboard/DashboardPracto', title: 'Dashboard', icon: 'fa fa-tachometer', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                },
                {
                    path: '/Aggregator/Patient/Forms/form', title: 'Uninsured', icon: 'ft-aperture', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                },
                {
                    path: '/Aggregator/Patient/Reimbursement/Add_New_Patient_Ayuhealth', title: 'Reimbursement', icon: 'ft-aperture', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                },
              
                {
                  path: '/Aggregator/Patient/Invoices/Invoice', title: 'Invoices', icon: 'ft-aperture', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
              },

            ]
        },
    )
}

if (sessionStorage.getItem('tatkaal') == 'true') {
    agROUTES.push(
        {
            path: '', title: 'TATKAAL', icon: 'ft-aperture', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
            submenu: [
                {
                    path: '/Admin/Payment/Worldline-Dashboard', title: 'Dashboard', icon: 'fa fa-user', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                },
                {
                    path: '/Admin/Payment/Worldline-Payment', title: 'Initiate Payment', icon: 'fa fa-user', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                },
                {
                    path: '/Admin/Payment/Worldline-List', title: 'Transactions', icon: 'fa fa-user', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                }
            ]
        },
    )
}
   
// if (sessionStorage.getItem('patientFinancing') == 'true') {
//     agROUTES.push(
//         {
//             path: '', title: 'Invoices', icon: 'ft-aperture', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
//             submenu: [
//                 {
//                     path: '/Aggregator/Patient/Dashboard/DashboardPracto', title: 'Dashboard', icon: 'fa fa-tachometer', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
//                 },
//                 {
//                     path: '/Aggregator/Patient/Forms/form', title: 'Uninsured', icon: 'ft-aperture', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
//                 },
//                 {
//                     path: '/Aggregator/Patient/Reimbursement/Add_New_Patient', title: 'Reimbursement', icon: 'ft-aperture', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
//                 },
//                 {
//                   path: '/Aggregator/Patient/Invoices/Invoice', title: 'Invoices', icon: 'ft-aperture', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
//               },

//             ]
//         },
//     )
// }

return agROUTES
}
